import httpClient from '@/services/httpClient';
import { OrganizationOption } from '@/types/assignment';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export const AdminOrganizationService = {
  /**
   * List organizations the calling admin belongs to (or all orgs for super_admin).
   * Used to populate the organization dropdown in admin Create Team / Create Assignment forms.
   */
  listMyOrganizations: async (): Promise<OrganizationOption[]> => {
    const response = await httpClient.get<ApiResponse<OrganizationOption[]>>('/admin/organizations');
    return response.data;
  }
};
